import { of } from "rxjs";
import { map, mergeMap, catchError, retryWhen, delay } from "rxjs/operators";
import { ofType } from "redux-observable";
import { connectionService, postService } from "../../../common/services";
import * as actionTypes from "./actionTypes";
import * as postsActions from "./actions";

export function fetchPost(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_ONE),
    mergeMap(({ payload }) => {
      return postService.getPostById(payload).pipe(
        map((res) => postsActions.fetchPostSuccess(res.responceObject.records)),
        catchError((error) => {
          console.log(error);
        })
      );
      // ajax({
      //   url: 'https://ayh1d856pl.execute-api.ap-southeast-2.amazonaws.com/PROD/posts',
      //   method: 'POST',
      //   headers: {
      //     "Authorization": payload.token,
      //     "Content-Type": "application/json"
      //   },
      //   body: payload.data
      // })
      //   .pipe(
      //     map(res => {

      //       console.log('res...', res)
      //     }),
      //     catchError(error => {
      //       console.log('error....', error)
      //     }))
    })
  );
}

export function fetchPosts(action$) {
  // return action$.pipe(
  //   ofType(actionTypes.FETCH_COLLECTION),
  //   mergeMap(() => {

  //   })
  // )

  return action$.pipe(
    ofType(actionTypes.FETCH_COLLECTION),
    mergeMap(({ payload }) => {
      return connectionService.getPosts(payload).pipe(
        map((res) =>
          postsActions.fetchPostsSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
  // .map(action => action.payload)
  // .switchMap(params => {
  //   return Observable.fromPromise(
  //     axios.get(`http://localhost:8081/posts?${querystring.stringify(params)}`)
  //   ).map(res => postsActions.fetchPostsSuccess(res.data, params));
  // });
}

export function updatePost(action$) {
  return action$.pipe(
    ofType(actionTypes.UPDATE),
    mergeMap(({ payload }) => {
      console.log("epic...payload...", payload);
      return postService.updatePost(payload).pipe(
        map((res) =>
          postsActions.updatePostSuccess(res.responceObject.records.data)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}

// const createPost = action$ =>
//   action$.pipe(
//     ofType(actionTypes.CREATE),
//     mergeMap(({payload}) => {
//       console.log(payload)
//     })
//   );

export function createPost(action$) {
  return action$.pipe(
    ofType(actionTypes.CREATE),
    mergeMap(({ payload }) => {
      return postService.addPost(payload).pipe(
        map((res) =>
          postsActions.createPostSuccess(res.responceObject.records.data)
        ),
        retryWhen((error$) =>
          error$.pipe(
            delay(90000),
            map((val) => {
              console.log(val);
              payload.retry -= 1;
              if (payload.retry === 0) {
                throw new Error(val);
              }
            })
          )
        ),
        catchError((error) =>
          of({
            type: actionTypes.CREATE_FAILED,
            payload: error.message,
            error: true,
          })
        )
      );
      // ajax({
      //   url: 'https://ayh1d856pl.execute-api.ap-southeast-2.amazonaws.com/PROD/posts',
      //   method: 'POST',
      //   headers: {
      //     "Authorization": payload.token,
      //     "Content-Type": "application/json"
      //   },
      //   body: payload.data
      // })
      //   .pipe(
      //     map(res => {

      //       console.log('res...', res)
      //     }),
      //     catchError(error => {
      //       console.log('error....', error)
      //     }))
    })
  );
}

export function deletePost(action$) {
  return action$.pipe(
    ofType(actionTypes.DELETE),
    mergeMap(({ payload }) => {
      return postService.deletePost(payload).pipe(
        map((res) => postsActions.deletePostSuccess(payload)),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}

export function getPostsSignedUrl(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_POSTS_SIGNED_URL),
    mergeMap(({ payload }) => {
      return postService.getPostsSignedUrl(payload).pipe(
        map((res) =>
          postsActions.getPostsSignedUrlSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}

export function fetchPostsBySignedUrl(action$){
  return action$.pipe(
    ofType(actionTypes.FETCH_POSTS_BY_SIGNED_URL),
    mergeMap(({ payload }) => {      
      return postService.fetchPostsBySignedUrl(payload).pipe(
        map((res) =>
          postsActions.fetchPostsBySignedUrlSuccess(res)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}
